import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

export interface MonthlyKpiDataDTO {
  month: number;
  year: number;
  value: number;
  unit: string;
}

export interface FleetIndicatorsResponseDTO {
  fuelConsumption: MonthlyKpiDataDTO[];
  traveledDistance: MonthlyKpiDataDTO[];
}

export interface FleetIndicatorsFuelState {
  data: FleetIndicatorsResponseDTO | null;
  loading: boolean;
  error: string | null;
}

const initialState: FleetIndicatorsFuelState = { data: null, loading: false, error: null };

type FetchFleetIndicatorsParams = {
  vehicleIds: number[];
  startDate: string;
  endDate: string;
};

export const fetchFleetIndicatorsFuel = createAsyncThunk('fleetIndicators/fetch', async ({ vehicleIds, startDate, endDate }: FetchFleetIndicatorsParams) => {
  if (!vehicleIds?.length) throw new Error('At least one vehicleId must be provided.');

  const params = new URLSearchParams();
  vehicleIds.forEach(id => params.append('vehicleIds', id.toString()));
  params.append('startDate', startDate);
  params.append('endDate', endDate);

  const { data } = await axios.get<FleetIndicatorsResponseDTO>(`api/fleet-indicators?${params.toString()}`);
  return data;
});

export const fleetIndicatorsFuelSlice = createSlice({
  name: 'fleetIndicatorsFuel',
  initialState,
  reducers: {
    resetFleetIndicators(state) {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchFleetIndicatorsFuel.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFleetIndicatorsFuel.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchFleetIndicatorsFuel.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Erro ao carregar indicadores';
      });
  },
});

export const { resetFleetIndicators } = fleetIndicatorsFuelSlice.actions;
export default fleetIndicatorsFuelSlice.reducer;
